import React from 'react'
import { SelectInput } from 'react-admin'
import { useFormContext } from 'react-hook-form'
import { DEFAULT_SYNC_SCHEDULES } from '@thefront/pandipackV2/src/utils'

/**
 *
 * @param pauseInDropdown - will add 'paused' option if true
 * @param integrationScheduleList - integration-specific options to
 * override defaults
 * @returns {*}
 * @constructor
 */
export default ({ pauseInDropdown, integrationScheduleList }) => {
    const form = useFormContext()

    const scheduleOptions = integrationScheduleList ?? DEFAULT_SYNC_SCHEDULES

    if (pauseInDropdown) {
        const values = form.getValues()
        if (values.paused) {
            form.setValue('userSchedule', 'paused')
        }
        if (!scheduleOptions.some((option) => option.cron === 'paused')) {
            scheduleOptions.push({ cron: 'paused', schedule: 'paused' })
        }
    }

    return (
        <SelectInput
            className={'pandium-dropdown'}
            emptyText="Select option"
            emptyValue=""
            source="userSchedule"
            optionValue="cron"
            optionText="schedule"
            choices={scheduleOptions}
            sx={{
                width: '256px',
                '& > div.MuiInputBase-root > div': {
                    padding: '16px 12px 10px',
                },
            }}
            onChange={(ev) => {
                if (pauseInDropdown) {
                    form.setValue('paused', ev.target.value === 'paused')
                }
            }}
            label="Select"
            variant="outlined"
            inputProps={{ 'aria-label': 'Without label' }}
        />
    )
}
